export interface IStringDictionary {
    [name: string]: string;
}
